import { Box, Image, Text, VStack } from '@chakra-ui/react'
import { PitchSlideView } from '@src/components/sco/PitchDeckAuditor/model/types'

/**
 * Renders the real rendered slide thumbnail (`slideImageUrl`) when available,
 * degrading gracefully to a labelled placeholder when the back-end render is missing
 * (thumbnail rendering fails soft server-side).
 */
export function SlideThumb({
  slide,
  width = '72px',
  isActive = false,
}: {
  slide: PitchSlideView
  width?: string
  isActive?: boolean
}) {
  const isLarge = parseInt(width) > 150
  return (
    <Box
      aspectRatio={16 / 9}
      bg={'bg.muted'}
      borderColor={isActive ? 'colorPalette.border' : 'border.muted'}
      borderRadius={'sm'}
      borderWidth={'1px'}
      boxShadow={'xs'}
      flexShrink={0}
      overflow={'hidden'}
      width={width}
    >
      {slide.slideImageUrl ? (
        <Image
          alt={slide.name}
          height={'full'}
          loading={'lazy'}
          objectFit={'cover'}
          src={slide.slideImageUrl}
          width={'full'}
        />
      ) : (
        <VStack align={'flex-start'} gap={1} height={'full'} justify={'center'} padding={isLarge ? 4 : 1.5}>
          <Text
            color={'fg.muted'}
            fontSize={isLarge ? 'md' : '7px'}
            fontWeight={'bold'}
            letterSpacing={'wide'}
            lineClamp={2}
            textTransform={'uppercase'}
          >
            {slide.name}
          </Text>
          <Box bg={'orange.solid'} borderRadius={'full'} height={isLarge ? '3px' : '1px'} width={'24%'} />
        </VStack>
      )}
    </Box>
  )
}
